// https://github.com/vercel/swr/issues/2125#issuecomment-1504812584
import { useEffect, useRef } from 'react';
import type { State } from 'swr';

export const useCacheProvider = () => {
  const cache = useRef<Map<string, State<unknown, unknown>>>(new Map());

  useEffect(() => {
    const appCache = sessionStorage.getItem('app-cache');
    if (appCache) {
      const map = new Map(JSON.parse(appCache) as Iterable<[string, State<unknown, unknown>]>);
      map.forEach((value, key) => {
        // only cache successful non-mutating results
        if (
          !value.isLoading &&
          !value.isValidating &&
          (value?.data as { status?: number } | undefined)?.status === 200
        ) {
          cache.current.set(key, value);
        }
      });
    }

    const saveCache = () => {
      console.log('Saving cache');
      const appCache = JSON.stringify(Array.from(cache.current.entries()));
      sessionStorage.setItem('app-cache', appCache);
    };

    window.addEventListener('beforeunload', saveCache);
    return () => window.removeEventListener('beforeunload', saveCache);
  }, []);

  return () => cache.current;
};
